// Native
import { useState } from "react"

// Components
import { Button, ButtonGroup, Tag, Td, Tooltip, Tr, useDisclosure } from "@chakra-ui/react"
import { Form, Icon, IconButton, Scope, Searchable, Section, Table } from "components"

// Config
import { Enums, Mask, Moment } from "config"

// Hooks
import { useConsultantBonusHistory } from "hooks"

// Screens
import Add from "./add"

export default function Extract({ data:consultant }){

    const [ page, setPage ] = useState(1)
    const [ term, setTerm ] = useState()
    const [ operation, setOperation ] = useState()
    const history = useConsultantBonusHistory(consultant.data?.id, page, term, operation)
    const add = useDisclosure()

    const columns = [
        { children: '', isNumeric: true }, 
        { children: 'Descrição' }, 
        { children: 'Valor', isNumeric: true }, 
        { children: 'Data', isNumeric: true }
    ]

    return(
    <>
    <Section title="Extrato de bonificações">
        <ButtonGroup size="xs" isDisabled={history.isFetching}>
            <Scope role="consultants_bonus"><Button children="Adicionar movimentação" leftIcon={<Icon name="add" />} colorScheme="orange" onClick={add.onOpen} /></Scope>
            <IconButton label="Atualizar" icon="refresh" isLoading={history.isFetching} onClick={history.refetch} />
        </ButtonGroup>
    </Section>

    <Searchable value={term} setValue={setTerm} placeholder="Pesquisar por descrição..">
        <Form.Select onChange={e => setOperation(e.target.value)} options={[{ label: 'Todos', value: '' }, { label: 'Adicionado', value: 1 }, { label: 'Removido', value: 2 }]} />
    </Searchable>

    <Table columns={columns} setPage={setPage} meta={history.data?.meta} loading={history.isLoading}>
        { history.data?.data?.map(item => <Item key={item.id} data={item} />) }
    </Table>

    {/* Screens */}
    <Add data={consultant} onSuccess={history.refetch} {...add} />
    </>
    )
}

const Item = ({ data:item, ...props }) => (
    <Tr {...props}>
        <Td isNumeric children={item.cod} />
        <Td children={item.label} />
        <Td isNumeric><Tooltip label={item.operation_label}><Tag size="sm" colorScheme={Enums.BonusOperation.data(item.operation).colorScheme} children={`R$ ${Mask.price(item.bonus)}`} /></Tooltip></Td>
        <Td isNumeric children={Moment(item.created_at).calendar()} />
    </Tr>
)